export enum ProductStandardField {
    sku = 'sku',
    ean = 'ean',
    externalId = 'externalId',
    manufacturer = 'manufacturer',
    supplier = 'supplier',
    type = 'type',
    description = 'description',
    availability = 'availability',
    floorHeating = 'structure.floorHeating',
    structure = 'structure.structure',
    baseIntegrated = 'installation.baseIntegrated',
    installationMethods = 'installation.methods',
    warrantYears = 'installation.warrantYears',
    abrasionClass = 'technicalParameters.abrasionClass',
    dualAbrasionClass = 'technicalParameters.dualAbrasionClass',
    waterResistance = 'technicalParameters.waterResistance',
    variantSku = 'variant.sku',
    variantDimensions = 'variant.dimensions',
    variantThickness = 'variant.thickness',
    selectedPattern = 'selectedPattern',
}

export const productStandardFieldOrder: { [key: string]: number } = {
    [ProductStandardField.availability]: 0,
    [ProductStandardField.description]: 1,
    [ProductStandardField.sku]: 2,
    [ProductStandardField.variantSku]: 3,
    [ProductStandardField.ean]: 4,
    [ProductStandardField.externalId]: 5,
    [ProductStandardField.manufacturer]: 6,
    [ProductStandardField.supplier]: 7,
    [ProductStandardField.type]: 8,
    [ProductStandardField.floorHeating]: 9,
    [ProductStandardField.structure]: 10,
    [ProductStandardField.baseIntegrated]: 11,
    [ProductStandardField.installationMethods]: 12,
    [ProductStandardField.warrantYears]: 13,
    [ProductStandardField.dualAbrasionClass]: 14,
    [ProductStandardField.waterResistance]: 15,
    [ProductStandardField.variantDimensions]: 16,
    [ProductStandardField.variantThickness]: 17,
    [ProductStandardField.selectedPattern]: 18,
};

export interface ProductCustomField {
    [key: string]: string[];
}
